import React from "react";
import classes from "./GameOverModal.module.css";
import { useTranslation } from "react-i18next";

const WrongWordModal = ({closeWrongWordModal}) => {
  const {t}=useTranslation();
  return (
    <div className={classes.container}>
      <div className={classes.sub_container}>
        <div className={classes.modal_img_container}>
          <img
            className={classes.modal_img}
            src="/assets/images/oops.png"
            alt="result"
          />
        </div>
        <div className={classes.modal_description}>
          <p>{t("143")}</p>
        </div>

        <div className={classes.buttons_container}>
          <button
            type="button"
            className={classes.back_btn}
            onClick={closeWrongWordModal}
          >
            {t("144")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WrongWordModal;
